import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteWarehouse($companyId: ID!, $id: ID!) {
    deleteWarehouse(companyId: $companyId, id: $id) {
      warehouse {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
